import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/companies';

class companiesService {
    /**
     * Tworzy nową firmę, wysyłając dane firmy do endpointu.
     * 
     * @param {Object} company - Obiekt zawierający dane nowej firmy, którą chcemy utworzyć.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnym utworzeniu firmy.
     */
    createCompany(company) {
        return axios.post(API_URL, company);
    }

    /**
     * Pobiera listę wszystkich firm.
     * 
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera zawierającą wszystkie firmy.
     */
    getAllCompanies() {
        return axios.get(API_URL);
    }

    getAllCompaniesArchive() {
        return axios.get(API_URL + '/archive');
    }

    /**
     * Pobiera dane firmy na podstawie jej identyfikatora (ID).
     * 
     * @param {number|string} id - ID firmy, którą chcemy pobrać.
     * @returns {Promise<Object>} Zwraca dane firmy o podanym ID.
     */
    getCompanyById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    /**
     * Aktualizuje dane firmy na podstawie jej identyfikatora (ID).
     * 
     * @param {number|string} id - ID firmy, którą chcemy zaktualizować.
     * @param {Object} updatedCompany - Obiekt zawierający zaktualizowane dane firmy.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnej aktualizacji firmy.
     */
    updateCompany(id, updatedCompany) {
        return axios.put(`${API_URL}/${id}`, updatedCompany);
    }

    /**
     * Usuwa firmę na podstawie jej identyfikatora (ID).
     * 
     * @param {number|string} id - ID firmy, którą chcemy usunąć.
     * @returns {Promise<void>} Zwraca odpowiedź z serwera po pomyślnym usunięciu firmy.
     */
    deleteCompany(id) {
        return axios.delete(`${API_URL}/${id}`);
    }

    restoreCompany(id) {
        return axios.put(`${API_URL}/${id}/restore`);
    }
}

export default new companiesService();
